import { StubPage } from '../components/StubPage';

export function DocGeneratorPage(): JSX.Element {
  return <StubPage navKey="docGenerator" />;
}
